import { LeistungIndexTag } from './LeistungIndexTag.tsx';

type LeistungIndexTagsProps = {
  leistungstemplates: { index: number; leistungstemplateId: string }[];
};

export const LeistungIndexTags = function ({ leistungstemplates }: LeistungIndexTagsProps) {
  if (leistungstemplates.length === 0) {
    return null;
  }

  return (
    <div className="flex gap-4">
      {leistungstemplates.map((leistungstemplate) => (
        <LeistungIndexTag key={leistungstemplate.leistungstemplateId} index={leistungstemplate.index} />
      ))}
    </div>
  );
};
